module.exports = __webpack_public_path__ + "static/img/farbklecks.cc61788.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/farbklecks.png
// module id = cHXT
// module chunks = 1